module.exports = __webpack_public_path__ + "img/Vector_6.d4876b69.svg";